import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../../Component/AuthComponent/Login";
import Signup from "../../Component/AuthComponent/Signup";
import ForgotPassword from "../../Component/AuthComponent/ForgotPassword";
import Dashboard from "../../Component/SidebarComponent/Dashboard";
import Deposit from "../../Component/SidebarComponent/Deposit";
import Withdraw from "../../Component/SidebarComponent/Withdraw";
import WithdrawalHistory from "../../Component/SidebarComponent/WithdrawalHistory";
import DepositHistory from "../../Component/SidebarComponent/DepositHistory";
import TransferHistory from "../../Component/SidebarComponent/TransferHistory";
import WalletHistory from "../../Component/SidebarComponent/WalletHistory";
import UserProfile from "../../Component/SidebarComponent/UserProfile";
import EditProfile from "../../Component/SidebarComponent/EditProfile";
import CopyTrading from "../../Component/SidebarComponent/CopyTrading";
import TraderDetails from "../../Component/SidebarComponent/TraderDetails";
import CopierArea from "../../Component/SidebarComponent/CopierArea";
import ConditionsPage from "../../Component/SidebarComponent/ConditionsPage";
import { ProfileContext } from "../ProfileProvider";
import ChangePassword from "../../Component/SidebarComponent/ChangePassword";
import ErrorPage from "../../Component/CoustamComponent/ErrorPage";
import UserKyc from "../../Component/SidebarComponent/UserKyc";
import ForgotPinNumber from "../../Component/SidebarComponent/ForgotPinNumber";
import ManualUserKyc from "../../Component/SidebarComponent/ManualUserKyc";
import SupportMessage from "../../Component/SidebarComponent/SupportMessage";
import SupportList from "../../Component/SidebarComponent/SupportList";

function Routing() {
  const Authtoken = sessionStorage.getItem("token");
  const { loginDetails } = useContext(ProfileContext);


  return (

    <Routes>

     <Route
        path="/"
        element={Authtoken ? (<Navigate to="/dashboard" replace />) : (<Login />)}
      />

      <Route
        path="/signup"
        element={Authtoken ? (<Navigate to="/dashboard" replace />) : (<Signup />)}
      />

      <Route
        path="/forgot_password"
        element={Authtoken ? (<Navigate to="/dashboard" replace />) : (<ForgotPassword />)}
      />

      <Route
        path="/change_password"
        element={Authtoken ? <ChangePassword /> : <Navigate to="/" replace />}
      />


      <Route
        path="/dashboard"
        element={Authtoken ? <Dashboard /> : <Navigate to="/" replace />}
      />

      <Route
        path="/deposit"
        element={Authtoken ? <Deposit /> : <Navigate to="/" replace />}
      />

      <Route
        path="/withdraw"
        element={Authtoken ? <Withdraw /> : <Navigate to="/" replace />}
      />

      <Route
        path="/forgot-pin"
        element={Authtoken ? <ForgotPinNumber /> : <Navigate to="/" replace />}
      />


      <Route
        path="/withdrawal_history"
        element={Authtoken ? <WithdrawalHistory /> : <Navigate to="/" replace />}
      />

      <Route
        path="/deposit_history"
        element={Authtoken ? <DepositHistory /> : <Navigate to="/" replace />}
      />
      <Route
        path="/transfer_history"
        element={Authtoken ? <TransferHistory /> : <Navigate to="/" replace />}
      />
      <Route
        path="/wallet_history"
        element={Authtoken ? <WalletHistory /> : <Navigate to="/" replace />}
      />
      <Route
        path="/user_profile"
        element={Authtoken ? <UserProfile /> : <Navigate to="/" replace />}
      />
      <Route
        path="/edit_profile"
        element={Authtoken ? <EditProfile /> : <Navigate to="/" replace />}
      />
      <Route
        path="/copy_trading"
        element={Authtoken ? <CopyTrading /> : <Navigate to="/" replace />}
      />
      <Route
        path="/trader_details"
        element={Authtoken ? <TraderDetails /> : <Navigate to="/" replace />}
      />
      <Route
        path="/copier_area"
        element={Authtoken ? <CopierArea /> : <Navigate to="/" replace />}
      />
      <Route
        path="/terms_conditions"
        element={Authtoken ? <ConditionsPage /> : <Navigate to="/" replace />}
      />

      <Route
        path="/update_kyc"
        element={Authtoken ? <ManualUserKyc /> : <Navigate to="/" replace />}
      />

      <Route
        path="/support-messages"
        element={Authtoken ? <SupportMessage /> : <Navigate to="/" replace />}
      />

      <Route
        path="/support"
        element={Authtoken ? <SupportList /> : <Navigate to="/" replace />}
      />


      <Route path="/verify_kyc" element={<UserKyc />} /> 

      <Route path="/*" element={<ErrorPage />} />

    </Routes>
  );
}

export default Routing;
